module.exports = __webpack_public_path__ + "assets/img/fourth_user_s.7cd6bf1b.svg";